import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../../app/store"
import { Message } from "@smartx/mikro-vt-client-api"

export interface IExtendedMessage extends Message {
  clicked: boolean
  readOnInit: boolean
}

interface NotificationsState {
  notifications: Array<IExtendedMessage>
}

const initialState: NotificationsState = {
  notifications: [],
}

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<any[]>) => {
      state.notifications = action.payload
    },
    updateNotification: (state, action: PayloadAction<IExtendedMessage>) => {
      let updatable = state.notifications.find(
        (notification) => notification.messageId === action.payload.messageId,
      )
      if (updatable) {
        updatable.clicked = action.payload.clicked
        updatable.read = action.payload.read
        updatable.readOnInit = action.payload.readOnInit
      }
    },
  },
})

export const { setNotifications, updateNotification } =
  notificationsSlice.actions
export const selectNotifications = (state: RootState) =>
  state.notifications.notifications
export default notificationsSlice.reducer
